/// <amd-module name="Artifacts/Root/protocols/services/ProtocolService" />
import { IProtocol } from "Artifacts/Root/protocols/types";
import * as Res from "Artifacts/Root/Resources";
import { IPackage } from "Artifacts/Root/types";
import { IVssService, Services, VssService } from "VSS/Platform/Context";

// Data structure type def to store mapping of protocols.
// key of the mapping is the protocol ID.
type ProtocolMapping = { [key: string]: IProtocol };

export interface IProtocolService extends IVssService {
  getProtocol(pkg: IPackage): IProtocol;
  getProtocolById(id: string): IProtocol;
  getProtocolMapping(): ProtocolMapping;
}

export class ProtocolService extends VssService implements IProtocolService {
  protected static registeredProtocols: ProtocolMapping = {};

  public static registerProtocol(protocol: IProtocol): void {
    ProtocolService.registeredProtocols[protocol.id.toLocaleLowerCase()] = protocol;
  }

  public getProtocol(pkg: IPackage): IProtocol {
    return this.getProtocolById(pkg.protocol);
  }

  public getProtocolById(id: string): IProtocol {
    const lowerName = id.toLocaleLowerCase();
    if (!Object.prototype.hasOwnProperty.call(ProtocolService.registeredProtocols, lowerName)) {
      throw new Error(Res.ProtocolNotFoundError);
    }
    return ProtocolService.registeredProtocols[lowerName];
  }

  public getProtocolMapping(): ProtocolMapping {
    return { ...ProtocolService.registeredProtocols };
  }
}

Services.add("IProtocolService", { serviceFactory: ProtocolService });
